import axios from 'axios';
import { localStorageUtils } from '../helpers/storageHelper';
import { refreshAccessToken } from './auth';
import { authUtils } from '../helpers/authHelper';

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    withCredentials: true,
})


api.interceptors.request.use(
    async (config) => {
        const accessToken = localStorageUtils.getLocalStorageItem('token');
        if (accessToken) {
            config.headers.Authorization = 'Bearer ' + accessToken;
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
)

let isRefreshing = false;
let refreshSubscribers = [];

api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry && originalRequest.url !== '/user/auth/refresh') {
            if (isRefreshing) {
                try {
                    const newAccessToken = await new Promise((resolve) => {
                        refreshSubscribers.push((accessToken) => {
                            resolve(accessToken);
                        })
                    });
                    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                    return api(originalRequest);
                } catch(error) {
                    console.log(error)
                    return Promise.reject(error);
                }
            } else {
                originalRequest._retry = true;
                isRefreshing = true;
                try {
                    const newAccessToken = await refreshAccessToken();
                    isRefreshing = false;
                    onAccessTokenRefreshed(newAccessToken);
                    originalRequest.headers.Authorization = 'Bearer ' + newAccessToken;
                    return api(originalRequest);
                } catch(error) {
                    isRefreshing = false;
                    onAccessTokenRefresheshFailed(error);
                    return Promise.reject(error);
                }
            }
        } else if (error.response.status === 401 && originalRequest.url === '/user/auth/refresh') {
            redirectOnFail()
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);


const onAccessTokenRefreshed = (accessToken) => {
    refreshSubscribers.forEach((callback) => callback(accessToken));
    refreshSubscribers = [];
}

const onAccessTokenRefresheshFailed = (error) => {
    refreshSubscribers.forEach((callback) => Promise.reject(error));
    refreshSubscribers = [];
}
const redirectOnFail = () => {
    authUtils.handleLogout();
    window.location.href = '/'
}
export default api;